var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';
import Loader from '../Loader';
import PropTypes from 'prop-types';

var Image = function (_PureComponent) {
  _inherits(Image, _PureComponent);

  function Image(props) {
    _classCallCheck(this, Image);

    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

    _this.componentWillUnmount = function () {
      _this.isComponentMounted = false;
    };

    _this._handleLoad = function (e) {
      var onImageLoaded = _this.props.onImageLoaded;


      if (_this.isComponentMounted) {
        _this.setState({
          isLoading: false,
          originWidth: e.target.width,
          originHeight: e.target.height
        }, function () {
          _this.state.onLoad();
          onImageLoaded && onImageLoaded(e.target.width, e.target.height);
        });
      }
    };

    _this._handleError = function () {
      if (_this.isComponentMounted) {
        _this.setState({ isLoading: true }, function () {
          return _this.state.onError();
        });
      }
    };

    _this.state = {
      isLoading: true,
      originWidth: 0,
      originHeight: 0,
      onLoad: function onLoad() {
        return undefined;
      },
      onError: function onError() {
        return undefined;
      }
    };
    _this.isComponentMounted = false;
    return _this;
  }

  _createClass(Image, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isComponentMounted = true;

      if (window && window.Image) {
        var image = new window.Image();

        image.src = this.props.src;
        image.onload = this._handleLoad;
        image.onerror = this._handleError;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isLoading = _state.isLoading,
          originWidth = _state.originWidth,
          originHeight = _state.originHeight;
      var _props = this.props,
          src = _props.src,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className,
          useOriginDimension = _props.useOriginDimension,
          maxWidth = _props.maxWidth,
          maxHeight = _props.maxHeight;
      var style = this.props.style;


      if (src && !isLoading) {
        style = _extends({}, style, {
          width: useOriginDimension ? originWidth : '',
          height: useOriginDimension ? originHeight : '',
          maxWidth: maxWidth,
          maxHeight: maxHeight,
          background: 'url(' + src + ') center/cover no-repeat'
        });
      }

      return React.createElement(
        'div',
        {
          className: className + ' ' + (!src ? ' default-image' : ''),
          style: style },
        React.createElement(
          'div',
          {
            className: 'image-loader-container',
            style: {
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
              background: '#CCC',
              opacity: +isLoading,
              transition: 'opacity 500ms'
            } },
          isLoading ? React.createElement(Loader, null) : null
        )
      );
    }
  }]);

  return Image;
}(PureComponent);

Image.propTypes = {
  /** source url of the image */
  src: PropTypes.string,
  /** General css class option */
  className: PropTypes.string,
  /** Optional dimensions for width and height of the image */
  useOriginDimension: PropTypes.string,
  /** Optional max width of the image */
  maxWidth: PropTypes.string,
  /** Optional max height of the image */
  maxHeight: PropTypes.string
};

Image.defaultProps = {
  src: '',
  className: '',
  useOriginDimension: '',
  maxWidth: '',
  maxHeight: ''
};

export default Image;